import { Konva } from "./Global.js";
const Captures = new Map();
// we may use this module for capturing touch events too
// so make sure we don't do something super specific to pointer
const SUPPORT_POINTER_EVENTS = Konva._global['PointerEvent'] !== undefined;
export function getCapturedShape(pointerId) {
    return Captures.get(pointerId);
}
export function createEvent(evt) {
    return {
        evt,
        pointerId: evt.pointerId,
    };
}
export function hasPointerCapture(pointerId, shape) {
    return Captures.get(pointerId) === shape;
}
export function setPointerCapture(pointerId, shape) {
    var _a;
    releaseCapture(pointerId);
    const stage = shape.getStage();
    if (!stage)
        return;
    Captures.set(pointerId, shape);
    if (SUPPORT_POINTER_EVENTS) {
        // capture on the DOM level too, so the stage keeps receiving the events
        // of that pointer even when it moves outside of the stage container
        // https://github.com/konvajs/konva/issues/1992
        try {
            (_a = stage.content) === null || _a === void 0 ? void 0 : _a.setPointerCapture(pointerId);
        }
        catch (e) {
            // capture is possible only for an active pointer;
            // ids of mouse and touch events (999 and touch identifiers) and
            // programmatic calls outside of a pointer event land here
        }
        shape._fire('gotpointercapture', createEvent(new PointerEvent('gotpointercapture')));
    }
}
// a destroyed node must not keep receiving the events of its pointer
export function releaseCapturesOf(node) {
    Captures.forEach((shape, pointerId) => {
        if (shape === node) {
            releaseCapture(pointerId);
        }
    });
}
export function releaseCapture(pointerId, target) {
    var _a;
    const shape = Captures.get(pointerId);
    // a node can only release its own capture
    if (!shape || (target && shape !== target))
        return;
    const stage = shape.getStage();
    Captures.delete(pointerId);
    if (SUPPORT_POINTER_EVENTS) {
        try {
            (_a = stage === null || stage === void 0 ? void 0 : stage.content) === null || _a === void 0 ? void 0 : _a.releasePointerCapture(pointerId);
        }
        catch (e) {
            // same as in setPointerCapture: the pointer may not be active
        }
        shape._fire('lostpointercapture', createEvent(new PointerEvent('lostpointercapture')));
    }
}
